var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import Scrollbars from 'components/Scrollbars/Scrollbars';
import * as PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PageSimpleHeader from './PageSimpleHeader';
import PageSimpleSidebar from './PageSimpleSidebar';
var mobileHeaderHeight = 40;
var tabletHeaderHeight = 56;
var headerHeight = 56;
var toolbarHeight = 56;
var drawerWidth = 240;
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e;
    return ({
        root: {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100%',
            position: 'relative',
            flex: '1 0 auto',
            height: 'auto',
            backgroundColor: theme.palette.background.root
        },
        container: {
            maxWidth: '157rem',
            width: '100%',
            margin: '0 auto'
        },
        innerScroll: {
            flex: '1 1 auto',
            height: '100%'
        },
        wrapper: {
            display: 'flex',
            flexDirection: 'row',
            flex: '1 1 auto',
            zIndex: 2,
            maxWidth: '100%',
            minWidth: 0,
            height: '100%'
        },
        header: {
            '& .header-page-tytle': (_a = {
                    fontWeight: 600
                },
                _a[theme.breakpoints.up('xs')] = {
                    fontSize: '2.2rem',
                    height: mobileHeaderHeight,
                    minHeight: mobileHeaderHeight
                },
                _a[theme.breakpoints.up('md')] = {
                    fontSize: '2.4rem',
                    height: tabletHeaderHeight,
                    minHeight: tabletHeaderHeight
                },
                _a[theme.breakpoints.up('lg')] = {
                    height: headerHeight,
                    minHeight: headerHeight,
                    fontSize: '2.6rem'
                },
                _a)
        },
        topBg: {
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            height: headerHeight,
            pointerEvents: 'none'
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 1 auto',
            overflow: 'auto',
            '-webkit-overflow-scrolling': 'touch',
            zIndex: 9999
        },
        contentBeforeToolbar: {},
        toolbar: {
            height: toolbarHeight,
            minHeight: toolbarHeight,
            display: 'flex',
            alignItems: 'center'
        },
        content: {
            flex: '1 0 auto'
        },
        sidebarWrapper: {
            overflow: 'hidden',
            backgroundColor: 'transparent',
            position: 'absolute',
            '&.permanent': (_b = {},
                _b[theme.breakpoints.up('lg')] = {
                    position: 'relative'
                },
                _b)
        },
        sidebar: {
            position: 'absolute',
            '&.permanent': (_c = {},
                _c[theme.breakpoints.up('lg')] = {
                    backgroundColor: theme.palette.background["default"],
                    color: theme.palette.text.primary,
                    position: 'relative'
                },
                _c),
            width: drawerWidth,
            height: '100%'
        },
        leftSidebar: (_d = {},
            _d[theme.breakpoints.up('lg')] = {
                borderRight: '1px solid ' + theme.palette.divider,
                borderLeft: 0
            },
            _d),
        rightSidebar: (_e = {},
            _e[theme.breakpoints.up('lg')] = {
                borderLeft: '1px solid ' + theme.palette.divider,
                borderRight: 0
            },
            _e),
        sidebarHeader: {
            height: headerHeight,
            minHeight: headerHeight,
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText
        },
        sidebarHeaderInnerSidebar: {
            backgroundColor: 'transparent',
            color: 'inherit',
            height: 'auto',
            minHeight: 'auto'
        },
        sidebarContent: {
        // [theme.breakpoints.down('md')]: {
        // 	backgroundColor: 'transparent' + '!important',
        // },
        },
        backdrop: {
            position: 'absolute'
        }
    });
});
var PageSimple = React.forwardRef(function (props, ref) {
    var leftSidebarRef = useRef(null);
    var rightSidebarRef = useRef(null);
    var rootRef = useRef(null);
    var location = useLocation();
    var classes = useStyles(props || {
        root: 'w-full bg-slate-200',
        topBg: 'hidden',
        contentWrapper: 'max-w-full',
        content: 'flex flex-col'
    });
    return (_jsxs("div", __assign({ className: clsx(classes.root, props.className, props.innerScroll && classes.innerScroll), ref: rootRef }, { children: [_jsx("div", { className: clsx(classes.header, classes.topBg) }, void 0), _jsxs(Box, __assign({ id: "page container", className: clsx('flex flex-auto container flex-col z-10') }, { children: [props.header && props.sidebarInner && _jsx(PageSimpleHeader, { header: props.header, classes: classes }, void 0), _jsxs("div", __assign({ className: classes.wrapper }, { children: [(props.leftSidebarHeader || props.leftSidebarContent) && (_jsx(PageSimpleSidebar, { position: "left", header: props.leftSidebarHeader, content: props.leftSidebarContent, variant: props.leftSidebarVariant || 'permanent', innerScroll: props.innerScroll, sidebarInner: props.sidebarInner, classes: classes, ref: leftSidebarRef, rootRef: rootRef }, void 0)), props.contentToolbar && (_jsxs(Scrollbars, __assign({ className: clsx(classes.contentWrapper, 'h-full'), enable: props.innerScroll && !props.sidebarInner, scrollToTopOnChildChange: props.innerScroll }, { children: [props.header && !props.sidebarInner && (_jsx(PageSimpleHeader, { header: props.header, classes: classes }, void 0)), _jsxs("div", __assign({ className: 'h-full overflow-y-hidden' }, { children: [props.contentBeforeToolbar && (_jsx("div", __assign({ className: clsx(classes.container, 'p-16') }, { children: _jsx("div", __assign({ className: classes.contentBeforeToolbar }, { children: props.contentBeforeToolbar }), void 0) }), void 0)), _jsx("div", __assign({ className: clsx(classes.container, 'h-full xs:px-8 md:px-12 xl:px-24 xs:mt-8 md:mt-12') }, { children: _jsxs("div", __assign({ className: clsx(!props.hideShadowContainer && 'tw-page-container-shadow ', 'h-full pt-0') }, { children: [props.contentToolbar && (_jsx("div", __assign({ className: classes.toolbar }, { children: props.contentToolbar }), void 0)), props.content && _jsx("div", __assign({ className: clsx(classes.content) }, { children: props.content }), void 0)] }), void 0) }), void 0)] }), void 0)] }), void 0)), !props.contentToolbar && (_jsxs(Scrollbars, __assign({ className: clsx(classes.contentWrapper, 'h-full'), enable: props.innerScroll && !props.sidebarInner, scrollToTopOnChildChange: props.innerScroll }, { children: [props.breadcrumbs && location.key && (_jsx("div", __assign({ className: clsx(classes.container, 'xs:px-8 md:px-12 xl:px-24 xs:mt-8 md:mt-12') }, { children: props.breadcrumbs }), void 0)), props.header && !props.sidebarInner && (_jsx(PageSimpleHeader, { header: props.header, classes: classes }, void 0)), props.contentAfterHeader && props.contentAfterHeader.length > 0 && (_jsx("div", __assign({ className: clsx(classes.container, 'content-after-header flex flex-col xs:px-8 md:px-12 xl:px-24 xs:mt-8 md:mt-12') }, { children: props.contentAfterHeader.map(function (content, index) {
                                            return (_jsx("div", __assign({ className: clsx('h-full') }, { children: content }), index));
                                        }) }), void 0)), props.filterPanel && (_jsx("div", __assign({ className: clsx(classes.container, 'xs:px-8 md:px-12 xl:px-24 xs:mt-8 md:mt-12') }, { children: props.filterPanel && _jsx("div", __assign({ className: clsx('h-full') }, { children: props.filterPanel }), void 0) }), void 0)), _jsx("div", __assign({ className: clsx(classes.container, 'h-full xs:px-8 md:px-12 xl:px-24 xs:my-8 md:my-12') }, { children: props.content && (_jsx("div", __assign({ className: clsx(classes.content, 'h-full') }, { children: props.content }), void 0)) }), void 0)] }), void 0)), (props.rightSidebarHeader || props.rightSidebarContent) && (_jsx(PageSimpleSidebar, { position: "right", header: props.rightSidebarHeader, content: props.rightSidebarContent, variant: props.rightSidebarVariant || 'permanent', innerScroll: props.innerScroll, sidebarInner: props.sidebarInner, classes: classes, ref: rightSidebarRef, rootRef: rootRef }, void 0))] }), void 0)] }), void 0)] }), void 0));
});
PageSimple.propTypes = {
    className: PropTypes.string || undefined,
    leftSidebarHeader: PropTypes.node,
    leftSidebarContent: PropTypes.node,
    leftSidebarVariant: PropTypes.node,
    rightSidebarHeader: PropTypes.node,
    rightSidebarContent: PropTypes.node,
    rightSidebarVariant: PropTypes.node,
    breadcrumbs: PropTypes.node,
    header: PropTypes.node,
    content: PropTypes.node,
    filterPanel: PropTypes.node || null,
    contentBeforeToolbar: PropTypes.node,
    contentToolbar: PropTypes.node,
    contentAfterHeader: PropTypes.arrayOf(PropTypes.node),
    sidebarInner: PropTypes.bool,
    innerScroll: PropTypes.bool,
    hideShadowContainer: PropTypes.bool
};
PageSimple.defaultProps = {};
export default React.memo(PageSimple);
